import fa from '../messages/fa.json' with { type: 'json' };
import en from '../messages/en.json' with { type: 'json' };
import type { Locale } from './locale.ts';

export type MessageKey = keyof typeof fa;
export const messages: Record<Locale, Record<MessageKey, string>> = { fa, en: en as Record<MessageKey, string> };
export const getMessages = (locale: Locale) => messages[locale];
